<div class="text-center" [hidden]="editMode">
  <i class="fa fa-spin fa-spinner fa-3x"></i>
</div>
<job-alert-settings-edit
  [defaultSettings]="true"
  [canDelete]="false"
  [editMode]="editMode"
  (editModeChange)="editModeChange($event)"
></job-alert-settings-edit>
